import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-v-close",
  "use": "icon-v-close-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-v-close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h36v36H0z\" /><path d=\"M29.293 9.14 20.433 18l8.86 8.86a1 1 0 0 1 0 1.414l-1.019 1.019a1 1 0 0 1-1.414 0L18 20.433l-8.86 8.86a1 1 0 0 1-1.414 0l-1.019-1.019a1 1 0 0 1 0-1.414l8.86-8.86-8.86-8.86a1 1 0 0 1 0-1.414l1.019-1.019a1 1 0 0 1 1.414 0l8.86 8.86 8.86-8.86a1 1 0 0 1 1.414 0l1.019 1.019a1 1 0 0 1 0 1.414Z\" fill=\"gray\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol